import { z } from 'zod';
import { idArray, paymentReportsFilterSchema } from './shared.schema';

export const cashBasisPaymentRateTypeSchema = z.enum([
	'Monthly',
	'Validation',
	'Hotel Storage',
	'Office/Retail Rent',
	'Miscellaneous',
	'Applied Cash Credit',
	'Unapplied Cash Credit',
]);

export const cashBasisPaymentRateTypes = cashBasisPaymentRateTypeSchema.options;

export const cashBasisPaymentReportFormatSchema = z.enum(['csv', 'pdf', 'xlsx']);

export const cashBasisPaymentParametersSchema = z
	.object({
		transactionStartDate: z.iso.date(),
		transactionEndDate: z.iso.date().optional(),
		accountFilter: paymentReportsFilterSchema.optional(),
		rateTypes: z.array(cashBasisPaymentRateTypeSchema).min(1),
		areaIds: idArray.optional(),
		branchIds: idArray.optional(),
		districtIds: idArray.optional(),
		facilityIds: z.array(z.string()).optional(),
		format: cashBasisPaymentReportFormatSchema.default('csv'),
		facilityNumber: z.union([z.string(), z.number()]).optional(),
	})
	.superRefine((value, ctx) => {
		if (value.transactionEndDate && value.transactionEndDate < value.transactionStartDate) {
			ctx.addIssue({
				code: 'custom',
				path: ['transactionEndDate'],
				message: 'End date must be on or after start date',
			});
		}
	});

export type CashBasisPaymentRateType = z.infer<typeof cashBasisPaymentRateTypeSchema>;
export type CashBasisPaymentParameters = z.infer<typeof cashBasisPaymentParametersSchema>;
export type CashBasisPaymentReportFormat = z.infer<typeof cashBasisPaymentReportFormatSchema>;
